//@ts-check
import React from "react"
import Fab from "@material-ui/core/Fab"
import { useTranslation } from "react-i18next"
import { makeStyles } from "@material-ui/core/styles"
import store from "../store"
import { useStepIndex } from "./step-index-context"
const CONSTS = require("shared/consts")

function StepHeader({
  button = undefined,
  skipStepNumber = false
}) {

  const { t } = useTranslation()
  var stepIndex=useStepIndex()
  const useStyles = makeStyles(theme => ({
    header: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
    }
  }))

  const classes = useStyles({})

  const isOneSide=store.getView()=="oneside"
  return 

  var stepName=store.steps[store.selectedStep].name ? `${store.steps[store.selectedStep].name} (${CONSTS.getStepNameByType(store.steps[store.selectedStep].type, store.isDryRun)})` : CONSTS.getStepNameByType(store.steps[store.selectedStep].type, store.isDryRun)
  
  if(isOneSide) {
    return <div>{stepName}</div>
  }

  return (<div className={classes.header}>
    <div>
      {skipStepNumber && <br />}
      {!skipStepNumber && <div css="
      font-size: 1.17em;
      font-weight: bold;
      margin: 25px 0 0 0;">
        <Fab
          css={`
            background-color: #ffffff !important;
            cursor: default !important;
          `}
          component="span"
          size="small"
          disableRipple
          disableFocusRipple
          aria-label={`${t("step_number")} ${store.selectedStep + 1}`}
        >
          {store.selectedStep + 1}
        </Fab>
        <span
          css={`
            margin-left: 16px;
          `}
        >
          {stepName}
        </span>
      </div>}
    </div>
    <div>
      {button}
    </div>
  </div>)
}

export default StepHeader
